import { importRepository } from '@/infrastructure/repositories';
import { HttpError } from '@/domain/entities';
import {
  ImportJob,
  UploadImportResponse,
  ImportStatusResponse,
  ImportHistoryResponse,
} from '@/domain/entities';

export class ImportService {
  async uploadFile(file: File): Promise<UploadImportResponse> {
    try {
      // Валидация файла
      if (!file) {
        throw new Error('Файл не выбран');
      }

      // Проверяем расширение
      const fileName = file.name.toLowerCase();
      const allowedExtensions = ['.xlsx', '.xls'];
      const hasValidExtension = allowedExtensions.some(ext => fileName.endsWith(ext));

      if (!hasValidExtension) {
        throw new Error('Поддерживаются только Excel файлы (.xlsx, .xls)');
      }

      // Проверяем размер (максимум 10 MB)
      const maxSize = 10 * 1024 * 1024; // 10 MB
      if (file.size > maxSize) {
        throw new Error('Размер файла не должен превышать 10 MB');
      }

      return await importRepository.uploadFile(file);
    } catch (error) {
      if (error instanceof HttpError) {
        throw error;
      }
      if (error instanceof Error) {
        throw error;
      }
      throw new Error('Не удалось загрузить файл');
    }
  }

  async getJobStatus(jobId: string): Promise<ImportStatusResponse> {
    try {
      return await importRepository.getJobStatus(jobId);
    } catch (error) {
      if (error instanceof HttpError) {
        throw error;
      }
      throw new Error('Не удалось получить статус импорта');
    }
  }

  async getHistory(limit: number = 20, offset: number = 0): Promise<ImportHistoryResponse> {
    try {
      return await importRepository.getHistory(limit, offset);
    } catch (error) {
      if (error instanceof HttpError) {
        throw error;
      }
      throw new Error('Не удалось получить историю импортов');
    }
  }

  async getJob(jobId: string): Promise<ImportJob> {
    try {
      return await importRepository.getJob(jobId);
    } catch (error) {
      if (error instanceof HttpError) {
        throw error;
      }
      throw new Error('Не удалось получить задачу импорта');
    }
  }

  async deleteJob(jobId: string): Promise<void> {
    try {
      await importRepository.deleteJob(jobId);
    } catch (error) {
      if (error instanceof HttpError) {
        throw error;
      }
      throw new Error('Не удалось удалить задачу импорта');
    }
  }
}

export const importService = new ImportService();

